import { CSSProperties } from "react";
import { View } from "react-native";

import { ReactComponent as CheckCircleActiveImg } from "../../img/btn-radio-incon-check-active.svg";
import { ReactComponent as CheckCircleInactiveImg } from "../../img/btn-radio-incon-check-inactive.svg";
import { ReactComponent as CheckSquareActiveImg } from "../../img/btn-checkbox-incon-circle-active.svg";
import { ReactComponent as CheckSquareInactiveImg } from "../../img/btn-checkbox-incon-circle-inactive.svg";
import { FONT } from "../../value/staticValues";

interface CustomCheckBoxProps {
    id: string;
    size?: number;
    label?: string;
    checked?: boolean;
    setCheckBoxStatus: Function;
    textStyle?: CSSProperties;
    disabled?: boolean;
}

export function CustomCircleCheckBox(props: CustomCheckBoxProps) {
    const checkbox_id = props.id;

    return (
        <label>
            <input style={{
                    border: 0,
                    background: '',
                    width: 0, height: 0,
                    padding: 0,
                    position: 'absolute', display: 'none'
                }} 
                id={checkbox_id} 
                type="checkbox"
                checked={props.checked}
                onChange={(e) =>{
                    props.setCheckBoxStatus(e.target.checked);
                }}
            />
            <View style={{flexDirection: "row", alignItems: "center"}}>
                <View style={{marginRight: 10}}>
                    {props.checked?
                        <CheckCircleActiveImg/>
                    :
                        <CheckCircleInactiveImg/>
                    }
                </View>
                <label 
                    htmlFor={checkbox_id} 
                    style={{
                        fontFamily: FONT.REGULAR,
                        fontSize: 13,
                        lineHeight: 0.92,
                        color: "#333"
                    }}
                >
                    {props.label}
                </label>
            </View>
        </label>
    );
}

export function CustomSquareCheckBox(props: CustomCheckBoxProps) {
    const checkbox_id = props.id;

    return (
        <label>
            <input style={{
                    border: 0,
                    background: '',
                    width: 0, height: 0,
                    padding: 0,
                    position: 'absolute', display: 'none'
                }} 
                id={checkbox_id} 
                type="checkbox"
                disabled={props.disabled}
                checked={props.checked}
                onChange={(e) =>{
                    props.setCheckBoxStatus(e.target.checked);
                }}
            />
            <View style={{flexDirection: "row", alignItems: "center"}}>
                <View style={{marginRight: 10}}>
                    {props.checked?
                        <CheckSquareActiveImg/>
                    :
                        <CheckSquareInactiveImg/>
                    }
                </View>
                <label 
                    htmlFor={checkbox_id} 
                    style={{
                        ...props.textStyle,
                        fontFamily: FONT.REGULAR,
                        fontSize: 13,
                        lineHeight: 0.92,
                        color: "#333"
                    }}
                >
                    {props.label}
                </label>
            </View>
        </label>
    );
}

